import { render } from "./mesas.vue?vue&type=template&id=4981b39d&scoped=true"
import script from "./mesas.vue?vue&type=script&lang=js"
export * from "./mesas.vue?vue&type=script&lang=js"

import "./mesas.vue?vue&type=style&index=0&id=4981b39d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4981b39d"]])

export default __exports__